module.exports = __webpack_public_path__ + "img/important-24.caef018d.svg";